var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0173 4.88348C7.27318 5.58937 5.24558 8.07949 5.24558 11.0449V15.286C5.24558 15.6768 4.92803 15.9936 4.53943 15.9936C3.75812 15.9936 3.125 16.6283 3.125 17.4073C3.125 18.1881 3.75913 18.8213 4.54215 18.8213H18.6732C19.456 18.8213 20.0904 18.1866 20.0904 17.4073C20.0904 16.6265 19.4543 15.9936 18.6759 15.9936C18.2859 15.9936 17.9698 15.6793 17.9698 15.286V11.0449C17.9698 8.08044 15.9427 5.58956 13.1981 4.88348V4.15322C13.1981 3.27256 12.4861 2.5625 11.6076 2.5625C10.7309 2.5625 10.0172 3.27477 10.0172 4.15322L10.0173 4.88348ZM9.13365 19.5283H14.0818C14.0818 20.8947 12.9741 22.0024 11.6077 22.0024C10.2414 22.0024 9.13365 20.8947 9.13365 19.5283Z",
    fill: "url(#paint0_linear_8633_15196)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8633_15196",
    x1: 20.0887,
    y1: 12.1907,
    x2: 2.24408,
    y2: 12.1907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005887"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.f13064980206c423423b3b0db7526d9a.svg";
export { ForwardRef as ReactComponent };